<script lang="ts" setup></script>

<template>
  <UButton
    :label="$t('support.donate')"
    to="/sponsor"
    color="primary"
    variant="outline"
    size="xl"
    icon="i-mingcute-heart-line"
    class="w-full"
  />
</template>
